import { render, staticRenderFns } from "./modifyPhone.vue?vue&type=template&id=23b56484&"
import script from "./modifyPhone.vue?vue&type=script&lang=js&"
export * from "./modifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./modifyPhone.vue?vue&type=style&index=0&id=23b56484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports